import React from "react";

function ArrowDownIcon() {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.91 -0.000161313L12.97 1.06084L7.193 6.83984C7.10043 6.93299 6.99036 7.00692 6.86911 7.05737C6.74786 7.10782 6.61783 7.13379 6.4865 7.13379C6.35517 7.13379 6.22514 7.10782 6.10389 7.05737C5.98264 7.00692 5.87257 6.93299 5.78 6.83984L-7.24192e-08 1.06084L1.06 0.000838744L6.485 5.42484L11.91 -0.000161313Z"
        fill="#667085"
      />
    </svg>
  );
}

export default ArrowDownIcon;
